import { render, staticRenderFns } from "./reservationListTrashCan.vue?vue&type=template&id=72fee574&"
import script from "./reservationListTrashCan.vue?vue&type=script&lang=ts&"
export * from "./reservationListTrashCan.vue?vue&type=script&lang=ts&"
import style0 from "./reservationListTrashCan.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports